"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MaterialListNoSortRequest = exports.MaterialListSortable = exports.MaterialList = exports.MaterialListUnstyledSortable = exports.MaterialListNoSortRequestUnstyled = exports.MaterialListUnstyled = void 0;
const list_item_1 = require("client/components/material/list/list-item");
const list_item_text_1 = require("client/components/material/list/list-item/list-item-text");
const material_ui_1 = require("material-ui");
const ArrowDropDown_1 = require("material-ui-icons/ArrowDropDown");
const ArrowDropUp_1 = require("material-ui-icons/ArrowDropUp");
const List_1 = require("material-ui/List");
// import { EditIcon } from "client/components/icons/edit";
// import Tooltip from '@material-ui/core/Tooltip';
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const React = require("react");
const react_1 = require("react");
const resizable_header_1 = require("../resizable-header");
require("./list.less");
// const styledRow = (row: any, index: number): ReactChild | JSX.Element => {
// };
const decorate = material_ui_1.withStyles(theme => ({
    // withMargin: {
    //   margin: "0 135px",
    // },
    withMargin: {
        margin: "0 0"
    },
    root: {}
}));
let MaterialListUnstyled = class MaterialListUnstyled extends react_1.Component {
    constructor() {
        super(...arguments);
        this.tableListRef = React.createRef();
        // public componentDidMount() {
        //   this.tableListRef = React.createRef<HTMLDivElement>();
        // }
        this.createSortHandler = (property) => {
            if (property === "NO_ACTION") {
                return;
            }
            property !== "qty" &&
                this.props.onRequestSort &&
                this.props.onRequestSort(property); // @TK added property !== 'qty'
        };
        this.blankRow = () => (React.createElement(list_item_1.MaterialListItem, { className: "no-rows" }, "No Rows"));
        this.renderHeader = () => {
            const { checkbox, columns = [], menu, order = "ASC", orderBy, withMargin = false, unstickHeader, decoration // B-104
             } = this.props;
            // B-104
            const isTop = (decoration === null || decoration === void 0 ? void 0 : decoration.top) === undefined ? 0 : decoration === null || decoration === void 0 ? void 0 : decoration.top;
            const type = (decoration === null || decoration === void 0 ? void 0 : decoration.type) === undefined ? 'unset' : decoration === null || decoration === void 0 ? void 0 : decoration.type;
            const zIndex = (decoration === null || decoration === void 0 ? void 0 : decoration.zIndex) === undefined ? '1' : decoration === null || decoration === void 0 ? void 0 : decoration.zIndex;
            // console.info("this.props.rows.length", this.props.rows.length);
            // console.info("this.props.resizableHeader", this.props.resizableheader);
            // console.info("this.tableListRef", this.tableListRef);
            return (React.createElement("div", { style: unstickHeader ? {} : { position: type, top: isTop, zIndex: zIndex } },
                this.props.resizableheader && this.props.rows.length ? (React.createElement(resizable_header_1.ResizableHeader, { columns: this.props.columns, tableListRef: this.tableListRef ? this.tableListRef.current : null })) : null,
                React.createElement(list_item_1.MaterialListItem, { category: withMargin
                        ? list_item_1.IListItemCategory.Header
                        : list_item_1.IListItemCategory.HeaderNoMargin },
                    columns.map((column, index) => (React.createElement("div", { className: `material-list__header-item ` + (column.className || ""), key: index, onClick: () => this.createSortHandler(column.id) },
                        index === 0 && checkbox && (React.createElement("span", { className: "material-list__header-checkbox" }, checkbox)),
                        React.createElement(list_item_text_1.MaterialListItemText, { header: true, primary: column.label === "No." ? column.label : column.label.toUpperCase() }),
                        orderBy === column.id && order === "ASC" && (React.createElement(List_1.ListItemIcon, null,
                            React.createElement(ArrowDropUp_1.default, null))),
                        orderBy === column.id && order === "DESC" && (React.createElement(List_1.ListItemIcon, null,
                            React.createElement(ArrowDropDown_1.default, null)))))),
                    menu && (React.createElement(list_item_text_1.MaterialListItemText, { header: true, primary: React.createElement("div", { className: "material-list__header-menu" }, menu) })))));
        };
    }
    render() {
        const { renderBlankRow = this.blankRow, checkbox, classes, columns = [], disablePadding = true, menu, order = "ASC", orderBy, renderRow, rows, withMargin = false, wideHeader = false, unstickHeader, queueListCustom = false, customClass = "" } = this.props;
        const tableListRef = this.tableListRef;
        return (
        // <div className="list" ref="tableListRef">
        // <div className="list" ref={this.tableListRef}>
        React.createElement("div", { className: "list", ref: tableListRef },
            wideHeader && React.createElement("div", { className: "list__dummy-header" }),
            React.createElement(List_1.default, { className: `material-list${customClass ? ` material-list__${customClass}` : ""}`, 
                // className={`material-list${
                //   queueListCustom ? " material-list__queue-list-custom" : ""
                // }`}
                classes: { root: withMargin ? classes.withMargin : classes.root }, disablePadding: disablePadding },
                columns.length !== 0
                    ? // <ListSubheader style={{ fontWeight: 'bold', paddingLeft: '0px', paddingRight: '0px' }} >
                        // <React.Fragment>
                        //   <ResizableHeader
                        //     columns={this.props.columns}
                        //     tableListRef={this.refs.tableListRef}
                        //   />
                        this.renderHeader()
                    : // </React.Fragment>
                        // </ListSubheader>
                        null,
                renderRow && rows.length > 0
                    ? rows.map(renderRow)
                    : renderBlankRow())));
    }
};
__decorate([
    mobx_1.observable
], MaterialListUnstyled.prototype, "tableListRef", void 0);
MaterialListUnstyled = __decorate([
    mobx_react_1.observer
], MaterialListUnstyled);
exports.MaterialListUnstyled = MaterialListUnstyled;
let MaterialListNoSortRequestUnstyled = class MaterialListNoSortRequestUnstyled extends react_1.Component {
    constructor() {
        super(...arguments);
        this.createSortHandler = (property) => {
            property !== "qty" &&
                this.props.onRequestSort &&
                this.props.onRequestSort(property); // @TK added property !== 'qty'
        };
        this.blankRow = () => (React.createElement(list_item_1.MaterialListItem, { className: "no-rows" }, "No Rows"));
    }
    render() {
        const { renderBlankRow = this.blankRow, checkbox, classes, columns = [], disablePadding = true, menu, order = "ASC", orderBy, renderRow, rows, withMargin = false, wideHeader = false } = this.props;
        return (React.createElement("div", { className: "list" },
            wideHeader && React.createElement("div", { className: "list__dummy-header" }),
            React.createElement(List_1.default, { className: "material-list", classes: { root: withMargin ? classes.withMargin : classes.root }, disablePadding: disablePadding },
                columns.length !== 0 ? (React.createElement(list_item_1.MaterialListItem, { category: withMargin
                        ? list_item_1.IListItemCategory.Header
                        : list_item_1.IListItemCategory.HeaderNoMargin },
                    checkbox && (React.createElement("span", { className: "material-list__header-checkbox" }, checkbox)),
                    columns.map((column, index) => (React.createElement("div", { className: "material-list__header-item", key: index },
                        React.createElement(list_item_text_1.MaterialListItemText, { header: true, primary: column.label.toUpperCase() }),
                        orderBy === column.id && order === "ASC" && (React.createElement(List_1.ListItemIcon, null,
                            React.createElement(ArrowDropUp_1.default, null))),
                        orderBy === column.id && order === "DESC" && (React.createElement(List_1.ListItemIcon, null,
                            React.createElement(ArrowDropDown_1.default, null)))))),
                    menu && React.createElement("div", { className: "material-list__header-menu" }, menu))) : null,
                renderRow && rows.length > 0
                    ? rows.map(renderRow)
                    : renderBlankRow())));
    }
};
MaterialListNoSortRequestUnstyled = __decorate([
    mobx_react_1.observer
], MaterialListNoSortRequestUnstyled);
exports.MaterialListNoSortRequestUnstyled = MaterialListNoSortRequestUnstyled;
let MaterialListUnstyledSortable = class MaterialListUnstyledSortable extends react_1.Component {
    constructor() {
        super(...arguments);
        this.createSortHandler = (property) => {
            this.props.onRequestSort && this.props.onRequestSort(property);
        };
        this.blankRow = () => (React.createElement(list_item_1.MaterialListItem, { className: "no-rows" }, "No Rows"));
    }
    componentWillMount() {
        this.props.makeSortable && this.props.makeSortable();
        // console.log("children: ", this.props.children);
    }
    componentDidMount() {
        this.props.onRequestSortPriority &&
            this.props.onRequestSortPriority("priority");
        this.props.makeSortable && this.props.makeSortable();
        // console.log("children: ", this.props.children);
    }
    render() {
        const { renderBlankRow = this.blankRow, checkbox, classes, columns = [], disablePadding = true, menu, renderRow, rows, rowGroup, // #TK
        withMargin = false, wideHeader = false } = this.props;
        // console.log("children: ", this.props.children);
        return (React.createElement("div", { className: "list" },
            wideHeader && React.createElement("div", { className: "list__dummy-header" }),
            React.createElement(List_1.default
            // className={`material-list sortable ${this.props.sortableClass ? this.props.sortableClass : 'sortable__group-management--notset'}`}
            , { 
                // className={`material-list sortable ${this.props.sortableClass ? this.props.sortableClass : 'sortable__group-management--notset'}`}
                className: `material-list sortable__group-management--notset sortable__group-management--group`, classes: { root: withMargin ? classes.withMargin : classes.root }, disablePadding: disablePadding, "data-group": rowGroup || "" },
                columns.length !== 0 ? (React.createElement(list_item_1.MaterialListItem, { className: "disabled", category: withMargin
                        ? list_item_1.IListItemCategory.Header
                        : list_item_1.IListItemCategory.HeaderNoMargin },
                    checkbox && (React.createElement("span", { className: "material-list__header-checkbox" }, checkbox)),
                    columns.map((column, index) => (React.createElement("div", { className: "material-list__header-item", key: index },
                        React.createElement(list_item_text_1.MaterialListItemText, { header: true, primary: column.label.toUpperCase() })))),
                    menu && React.createElement("div", { className: "material-list__header-menu" }, menu))) : null,
                renderRow && rows.length > 0
                    ? rows.map(renderRow)
                    : renderBlankRow())));
    }
};
MaterialListUnstyledSortable = __decorate([
    mobx_react_1.observer
], MaterialListUnstyledSortable);
exports.MaterialListUnstyledSortable = MaterialListUnstyledSortable;
exports.MaterialList = decorate(MaterialListUnstyled);
exports.MaterialListSortable = decorate(MaterialListUnstyledSortable);
exports.MaterialListNoSortRequest = decorate(MaterialListNoSortRequestUnstyled);



//////////////////
// WEBPACK FOOTER
// ./src/client/components/material/list/list.tsx
// module id = 3228
// module chunks = 0